import { render } from "./ProductLabelGroup.vue?vue&type=template&id=e8199f22"
import script from "./ProductLabelGroup.vue?vue&type=script&lang=js"
export * from "./ProductLabelGroup.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__